<template>
  <div
    class="input-group input-group--search"
    :class="{
      'input-group--search-lg': isLarge,
      'input-group--search-md': isMedium,
      'input-group--search-sm': isSmall,
      'input-group--without-search-btn': !withSearchBtn,
      }"
    >
    <input
      class="form-control input-group__text-input"
      type="text"
      v-model="filter"
      :class="{
        'input-lg': isLarge,
        'input-md': isMedium,
        'input-sm': isSmall
        }"
      :disabled="disabled"
      :placeholder="placeholder"
      @keypress.enter.prevent="updateAndExecute"
      @keyup.esc.prevent="clear"
      />
    <a
      class="input-group__text-clear"
      :class="{'text-muted': disabled}"
      :title="clearActionText"
      @click.prevent="clearAndExecute"
      >
      <i class="fa fa-fw fa-times"></i>
    </a>
    <div class="input-group-btn input-group-sm" v-if="withSearchBtn">
      <button
        class="btn btn-default input-group__text-submit"
        type="button"
        :class="{
          'btn-lg': isLarge,
          'btn-md': isMedium,
          'btn-sm': isSmall
          }"
        :disabled="disabled"
        @click="updateAndExecute"
        >
        <i class="fa fa-fw fa-search"></i>
        <span class="sr-only">Clear</span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'money',
    props: {
      value: {
        type    : String,
        default : ''
      },
      placeholder: {
        type    : String,
        default : 'Search'
      },
      clearActionText: {
        type    : String,
        default : 'Clear text'
      },
      size: {
        type: String,
        default: null
      },
      disabled: {
        type    : Boolean,
        default : false
      },
      withSearchBtn: {
        type: Boolean,
        default: true,
      },
      executeOnEnter: {
        type: Boolean,
        default: true,
      },
      executeOnClickClearBtn: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        filter: ''
      }
    },
    mounted() {
      this.filter = this.value
    },
    watch: {
      value(val) {
        this.filter = val
      },
      filter() {
        this.update()
      },
    },
    computed: {
      isLarge() {
        return 'lg' === this.size
      },
      isMedium() {
        return 'md' === this.size
      },
      isSmall() {
        return 'sm' === this.size
      }
    },
    methods: {
      updateAndExecute() {
        this.update()
        if (this.executeOnEnter) {
          this.execute()
        }
      },
      clearAndExecute() {
        this.clear()
        if (this.executeOnClickClearBtn) {
          this.execute()
        }
      },
      update() {
        this.$emit('input', this.filter)
      },
      execute() {
        this.$emit('execute')
      },
      clear() {
        this.filter = ''

        this.update()

        this.$emit('clear')
      }
    }
  }
</script>
